module.exports = __webpack_public_path__ + "img/tamilcoin.52dcfb3c.png";